import Request, { RequestParams, RequestPageParams } from './request'
import { getSingletonStore } from 'common/utils'
import { DIOX } from './index'

class TokenService extends Request {
  constructor(props: RequestParams) {
    super(props)
  }

  getTokenInfo(symbol: string) {
    return this.get<DIOX.MyTokenBase>('', { params: { module: 'token', action: 'baseinfo', symbol } })
  }

  getTokenList(query?: RequestPageParams) {
    return this.get<DIOX.TokenResponse>('', { params: { module: 'token', action: 'listtoken', ...query } })
  }

}

export default getSingletonStore<TokenService>(TokenService, { baseURL: '/api' })
